"use strict";
/**
 * Scheduler/class API types and helpers for Calendar.
 * Matches backend contract and package-calendar-controller dev App.tsx.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPutBody = exports.buildPostBody = exports.findClassIdBySessionId = exports.classesToEvents = exports.sessionDateTimeToUTC = exports.toApiTime = exports.toApiDateLocal = exports.toApiDate = exports.recurrenceToApi = void 0;
const calendar_controller_1 = require("@eagle-projects/calendar-controller");
const DAYS_OF_WEEK_API = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
function recurrenceToApi(rr) {
    var _a, _b, _c;
    if (!rr || rr.frequency === 'none') {
        return { enabled: false };
    }
    const ruleMap = { daily: 'DAILY', weekly: 'WEEKLY', monthly: 'MONTHLY', yearly: 'MONTHLY' };
    const rule = (_a = ruleMap[rr.frequency]) !== null && _a !== void 0 ? _a : 'WEEKLY';
    const daysOfWeek = ((_b = rr.byWeekday) !== null && _b !== void 0 ? _b : []).map((d) => DAYS_OF_WEEK_API[d]);
    return {
        enabled: true,
        rule,
        interval: (_c = rr.interval) !== null && _c !== void 0 ? _c : 1,
        daysOfWeek: daysOfWeek.length ? daysOfWeek : undefined,
        until: rr.until ? toApiDateLocal(rr.until) : undefined,
    };
}
exports.recurrenceToApi = recurrenceToApi;
function toApiDate(d) {
    const date = typeof d === 'string' ? new Date(d) : d;
    return date.toISOString().slice(0, 10);
}
exports.toApiDate = toApiDate;
/** Format a date as YYYY-MM-DD using local date components (avoids UTC off-by-one for date-only values like recurrence until). */
function toApiDateLocal(d) {
    const date = typeof d === 'string' ? new Date(d) : d;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
exports.toApiDateLocal = toApiDateLocal;
function toApiTime(d) {
    const date = typeof d === 'string' ? new Date(d) : d;
    const h = date.getUTCHours();
    const m = date.getUTCMinutes();
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
exports.toApiTime = toApiTime;
function getTimezoneOffsetMinutes(zone, utcDate) {
    var _a, _b, _c, _d;
    const utcHours = utcDate.getUTCHours();
    const utcMins = utcDate.getUTCMinutes();
    const utcMinsTotal = utcHours * 60 + utcMins;
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: 'numeric', minute: 'numeric', hour12: false });
    const parts = formatter.formatToParts(utcDate);
    const localHours = parseInt((_b = (_a = parts.find((p) => p.type === 'hour')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '0', 10);
    const localMins = parseInt((_d = (_c = parts.find((p) => p.type === 'minute')) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '0', 10);
    const localMinsTotal = localHours * 60 + localMins;
    return localMinsTotal - utcMinsTotal;
}
function sessionDateTimeToUTC(isoString, zone) {
    const d = new Date(isoString);
    const y = d.getUTCFullYear();
    const mo = d.getUTCMonth();
    const day = d.getUTCDate();
    const h = d.getUTCHours();
    const min = d.getUTCMinutes();
    const sec = d.getUTCSeconds();
    const provisionalUTC = Date.UTC(y, mo, day, h, min, sec);
    const offsetMs = getTimezoneOffsetMinutes(zone, new Date(provisionalUTC)) * 60 * 1000;
    return new Date(provisionalUTC - offsetMs).toISOString();
}
exports.sessionDateTimeToUTC = sessionDateTimeToUTC;
function participantsFromClass(apiClass, apiSession, user, attendees) {
    var _a;
    const organizerId = apiSession.organizerId || apiClass.organizerId;
    const participantIds = (((_a = apiSession.participantIds) === null || _a === void 0 ? void 0 : _a.length) ? apiSession.participantIds : apiClass.participantIds) || [];
    const list = [];
    // Organizer
    if ((user === null || user === void 0 ? void 0 : user.userId) === organizerId) {
        list.push((0, calendar_controller_1.userToParticipant)(user));
    }
    else {
        const organizerAtt = attendees.find((a) => a.userId === organizerId);
        if (organizerAtt) {
            list.push(Object.assign(Object.assign({}, (0, calendar_controller_1.attendeeToParticipant)(organizerAtt)), { role: 'organizer' }));
        }
        else {
            list.push({ id: organizerId, name: 'Organizer', role: 'organizer' });
        }
    }
    // Required participants
    participantIds.forEach((id) => {
        if (id === organizerId)
            return;
        const att = attendees.find((a) => a.userId === id);
        list.push(att ? (0, calendar_controller_1.attendeeToParticipant)(att) : { id, name: 'Participant', role: 'required' });
    });
    return list;
}
async function classesToEvents(classes, user, attendees) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const result = [];
    for (const c of classes || []) {
        for (const s of c.sessions || []) {
            const participants = participantsFromClass(c, s, user, attendees);
            const tz = s.timezone || c.timezone;
            const start = s.startDateTime;
            const end = s.endDateTime;
            const notifycationSettings = s.notificationSettings || c.notificationSettings;
            result.push({
                id: s.id,
                title: c.title,
                start,
                end,
                allDay: false,
                participants,
                extendedProps: {
                    classId: c.id,
                    classType: c.type === 'group' ? 'Group Tutoring' : '1:1 Tutoring',
                    status: s.status,
                    timezone: tz,
                    notifyStudentEmail: (_a = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.notifyStudentEmail) !== null && _a !== void 0 ? _a : false,
                    notifyStudentSMS: (_b = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.notifyStudentSMS) !== null && _b !== void 0 ? _b : false,
                    notifyTutorEmail: (_c = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.notifyTutorEmail) !== null && _c !== void 0 ? _c : false,
                    notifyTutorSMS: (_d = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.notifyTutorSMS) !== null && _d !== void 0 ? _d : false,
                    reminders: (_e = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.reminders) !== null && _e !== void 0 ? _e : [],
                    notifyTo: (_f = notifycationSettings === null || notifycationSettings === void 0 ? void 0 : notifycationSettings.notifyTo) !== null && _f !== void 0 ? _f : { mode: 'all' },
                    cancellationReason: (_g = s.notes) !== null && _g !== void 0 ? _g : undefined,
                    meetingLink: (_h = s.meetingLink) !== null && _h !== void 0 ? _h : undefined,
                    hostLink: (_j = s.hostLink) !== null && _j !== void 0 ? _j : undefined,
                    meetingProvider: (_k = s.meetingProvider) !== null && _k !== void 0 ? _k : undefined,
                    rsvp: (_l = s.rsvp) !== null && _l !== void 0 ? _l : { status: 'pending', respondedAt: null },
                    attendeeRsvps: (_m = s.attendees) !== null && _m !== void 0 ? _m : [],
                },
                recurrenceRule: ((_o = c.recurrence) === null || _o === void 0 ? void 0 : _o.enabled)
                    ? {
                        frequency: (((_p = c.recurrence.rule) === null || _p === void 0 ? void 0 : _p.toLowerCase()) || 'weekly'),
                        interval: (_q = c.recurrence.interval) !== null && _q !== void 0 ? _q : 1,
                        byWeekday: ((_r = c.recurrence.daysOfWeek) !== null && _r !== void 0 ? _r : []).map((d) => DAYS_OF_WEEK_API.indexOf(d)),
                        until: c.recurrence.until ? toApiDate(c.recurrence.until) : undefined,
                    }
                    : undefined,
            });
        }
    }
    return result;
}
exports.classesToEvents = classesToEvents;
function findClassIdBySessionId(classes, sessionId) {
    var _a;
    const c = classes.find((cl) => { var _a; return (_a = cl.sessions) === null || _a === void 0 ? void 0 : _a.some((s) => s.id === sessionId); });
    return (_a = c === null || c === void 0 ? void 0 : c.id) !== null && _a !== void 0 ? _a : null;
}
exports.findClassIdBySessionId = findClassIdBySessionId;
function buildPostBody(data, user, timezone) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const start = typeof data.start === 'string' ? new Date(data.start) : data.start;
    const end = typeof data.end === 'string' ? new Date(data.end) : data.end;
    const ext = data.extendedProps || {};
    const organizer = (_b = (_a = data.participants) === null || _a === void 0 ? void 0 : _a.find((p) => p.role === 'organizer')) !== null && _b !== void 0 ? _b : (_c = data.participants) === null || _c === void 0 ? void 0 : _c[0];
    const organizerId = (_e = (_d = organizer === null || organizer === void 0 ? void 0 : organizer.id) !== null && _d !== void 0 ? _d : user === null || user === void 0 ? void 0 : user.userId) !== null && _e !== void 0 ? _e : '';
    const participantIds = ((_f = data.participants) !== null && _f !== void 0 ? _f : []).filter((p) => p.id !== organizerId).map((p) => p.id);
    return {
        title: data.title || 'New Session',
        notes: (_g = data.description) !== null && _g !== void 0 ? _g : undefined,
        type: ext.classType === 'Group Tutoring' ? 'group' : 'One-to-one',
        organizerId,
        participantIds,
        startDate: toApiDate(start),
        endDate: toApiDate(end),
        startTime: toApiTime(start),
        endTime: toApiTime(end),
        timezone: (_j = (_h = ext.timezone) !== null && _h !== void 0 ? _h : timezone) !== null && _j !== void 0 ? _j : undefined,
        Recurrence: recurrenceToApi(data.recurrenceRule),
        notificationSettings: {
            notifyStudentEmail: (_k = ext.notifyStudentEmail) !== null && _k !== void 0 ? _k : false,
            notifyStudentSMS: (_l = ext.notifyStudentSMS) !== null && _l !== void 0 ? _l : false,
            notifyTutorEmail: (_m = ext.notifyTutorEmail) !== null && _m !== void 0 ? _m : false,
            notifyTutorSMS: (_o = ext.notifyTutorSMS) !== null && _o !== void 0 ? _o : false,
            reminders: ((_p = ext.reminders) !== null && _p !== void 0 ? _p : []).map((r) => ({ type: r.type, beforeMinutes: r.beforeMinutes })),
            notifyTo: (_q = ext.notifyTo) !== null && _q !== void 0 ? _q : { mode: 'all' },
        },
    };
}
exports.buildPostBody = buildPostBody;
function buildPutBody(data, user, timezone) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const start = data.start != null ? (typeof data.start === 'string' ? new Date(data.start) : data.start) : new Date();
    const end = data.end != null ? (typeof data.end === 'string' ? new Date(data.end) : data.end) : new Date();
    const ext = data.extendedProps || {};
    const organizer = (_b = (_a = data.participants) === null || _a === void 0 ? void 0 : _a.find((p) => p.role === 'organizer')) !== null && _b !== void 0 ? _b : (_c = data.participants) === null || _c === void 0 ? void 0 : _c[0];
    const organizerId = (_e = (_d = organizer === null || organizer === void 0 ? void 0 : organizer.id) !== null && _d !== void 0 ? _d : user === null || user === void 0 ? void 0 : user.userId) !== null && _e !== void 0 ? _e : '';
    const participantIds = ((_f = data.participants) !== null && _f !== void 0 ? _f : []).filter((p) => p.id !== organizerId).map((p) => p.id);
    return {
        title: (_g = data.title) !== null && _g !== void 0 ? _g : '',
        notes: (_h = data.description) !== null && _h !== void 0 ? _h : undefined,
        type: ext.classType === 'Group Tutoring' ? 'group' : 'One-to-one',
        organizerId,
        participantIds,
        startDate: toApiDate(start),
        endDate: toApiDate(end),
        startTime: toApiTime(start),
        endTime: toApiTime(end),
        timezone: (_k = (_j = ext.timezone) !== null && _j !== void 0 ? _j : timezone) !== null && _k !== void 0 ? _k : undefined,
        Recurrence: recurrenceToApi(data.recurrenceRule),
        notificationSettings: {
            notifyStudentEmail: (_l = ext.notifyStudentEmail) !== null && _l !== void 0 ? _l : false,
            notifyStudentSMS: (_m = ext.notifyStudentSMS) !== null && _m !== void 0 ? _m : false,
            notifyTutorEmail: (_o = ext.notifyTutorEmail) !== null && _o !== void 0 ? _o : false,
            notifyTutorSMS: (_p = ext.notifyTutorSMS) !== null && _p !== void 0 ? _p : false,
            reminders: ((_q = ext.reminders) !== null && _q !== void 0 ? _q : []).map((r) => ({ type: r.type, beforeMinutes: r.beforeMinutes })),
            notifyTo: (_r = ext.notifyTo) !== null && _r !== void 0 ? _r : { mode: 'all' },
        },
        createdBy: user === null || user === void 0 ? void 0 : user.userId,
    };
}
exports.buildPutBody = buildPutBody;
